import Vue from 'vue';
import { getLead as getLeadApiCall } from '../../api/lead';
import { GLOBAL_ERROR } from '../../utils/constants';
import { INITIAL_LEAD } from '../../utils/constants';

export function getLead({ commit }) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setLeadLoading', true);
      const lead = await getLeadApiCall();
      commit('setLead', lead || INITIAL_LEAD);
      commit('setLeadLoading', false);
      return resolve();
    } catch (err) {
      commit('setLeadLoading', false);
      if (err.status === 404) {
        commit('setLead', { ...INITIAL_LEAD });
        return resolve();
      } else {
        Vue.prototype.$euiNotifications.emit({
          notification: GLOBAL_ERROR,
          action: () => dispatch('getLead')
        });
      }
      return reject();
    }
  });
}
